import React, { useEffect, useState } from 'react';
import { Button, Form } from 'antd';
import TextInput from '../../../inputs/TextInput';
import { AddInfoContentService, GetInfoContentService } from '../../../services/infoContentServices';
import useTranslation from '../../../../hooks/translation/useTranslation';

function Notifications() {
  const { trans } = useTranslation();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await GetInfoContentService({
        type: 'notifications',
      });
      if (response.status === 'success') {
        form.setFieldsValue(JSON.parse(response.data.content || '{}'));
      } else {
        form.setFieldsValue({});
      }
    } catch {
      form.setFieldsValue({});
    }
    setIsLoading(false);
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const response = await AddInfoContentService({
        content: JSON.stringify(values),
        type: 'notifications',
      });
      if (response.status === 'success') {
        await fetchData();
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      {[
        {
          key: 'rides_not_found',
          title: 'რეისები ვერ მოიძებნა ტექსტი',
        },
        {
          key: 'tickets_sold',
          title: 'ბილეთები გაიყიდა ტექსტი',
        },
      ].map(({ key, title }) => (
        <div className="flex gap-4" key={key}>
          <p className="text-[16px] mt-[30px] mb-0">
            {title}
            :
          </p>
          <TextInput label="ქართულად" name={[key, 'ka']} />
          <TextInput label="ინგლისურად" name={[key, 'en']} />
        </div>
      ))}
      <Form.Item>
        <Button
          loading={isLoading}
          type="primary"
          htmlType="submit"
        >
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default Notifications;
